import { getTimeZone, useToast } from '@airship-platform/airship-patterns';
import { LoadingButton } from '@airship-platform/jam-web/components';
import { useNavigate } from 'react-router';
import {
  AppointmentProposal,
  useAppointmentProposals,
} from '../../../data-access/appointmentProposals';
import { useAppointments } from '../../../data-access/appointments';
import ROUTE_PATHS from '../../../routes/paths';

interface StartServiceCallButtonProps {
  appointmentId: string;
  proposal?: AppointmentProposal;
}

const StartServiceCallButton: React.FC<StartServiceCallButtonProps> = ({
  appointmentId,
  proposal,
}) => {
  const { createAppointmentProposal, isLoading, error } =
    useAppointmentProposals();
  const { currentAppointment } = useAppointments();

  const navigate = useNavigate();
  const toast = useToast();

  const createAndNavigate = () => {
    if (proposal) {
      navigate(
        ROUTE_PATHS.APPOINTMENT_PATH({
          appointmentId,
          appointmentProposalId: proposal.appointmentProposalId,
          path: 'options',
        })
      );
    } else {
      currentAppointment &&
        createAppointmentProposal(appointmentId, {
          jobId: currentAppointment.job.jobId,
          timeZone: getTimeZone(),
          installationType: 'REPLACE',
          proposalType: 'HVAC',
          surveyContacts: [],
          notes: '',
          customerExperience: { current: [], priorities: [] },
          mediaChecklist: { indoor: [], outdoor: [] },
          outageExperience: {
            eventConcerns: [],
            homeAppliances: [],
            homeSystems: [],
            technologyElectronics: [],
          },
        })
          .then((res) =>
            navigate(
              ROUTE_PATHS.APPOINTMENT_PATH({
                appointmentId: res.appointmentId,
                appointmentProposalId: res.appointmentProposalId,
                path: 'options',
              })
            )
          )
          .catch((error) => toast.showToast(`${error}`, 'error'));
    }
  };

  const caText = proposal
    ? ['COMPLETED', 'FINISHED'].includes(proposal.status)
      ? 'View'
      : 'Resume'
    : 'Build';
  const caTextError = error ? 'ERROR' : '';

  return (
    <LoadingButton loading={isLoading} onClick={() => createAndNavigate()}>
      {`${caText} proposal`} {caTextError}
    </LoadingButton>
  );
};

export default StartServiceCallButton;
